import { ButtonIcon } from "@/components/buttons/ButtonIcon.tsx";
import type { FC } from "react";
import type { ButtonBasicProps } from "@/components/buttons/shared.ts";
import { IconTick } from "@/icons/IconTick.tsx";
import { AiStates } from "@/types/ai.ts";

const backgroundColor = "#09C18A";
const disabledBackgroundColor = "#47DBAF";
const AiBackgroundColor = "#FF6FE7E5";
const AiDisabledBackgroundColor = "#FFA8F1";

// TODO: Figure out if I want to do this globally or not
interface ButtonCompleteProps extends ButtonBasicProps {
  text?: string;
  AiMode?: AiStates;
}

export const ButtonComplete: FC<ButtonCompleteProps> = ({ AiMode, onClick, text, flare }) => {
  return (
    <ButtonIcon
      onClick={onClick}
      icon={<IconTick />}
      text={text ?? "Complete"}
      backgroundColor={AiMode === AiStates.on ? AiBackgroundColor : backgroundColor}
      disabledBackgroundColor={
        AiMode === AiStates.on ? AiDisabledBackgroundColor : disabledBackgroundColor
      }
      flare={flare}
    />
  );
};
